/**
 * This is a compiled JS file.
 * Changes here could be overwritten. 
 * Contact your Shopify developers if changes need to be made.
 */

class ArticleQuickLinks extends HTMLElement {
    constructor() {
        super();

        // Hide quick links on load.
        this.classList.add('hidden');

        this.article = document.querySelector('.shopify-section.section.repeatable-content');
        this.headers = [...this.article?.querySelectorAll(':is(h1, h2, h3):not(.article-quick-links h3)')];
        this.markup = `<p class="article-quick-links__item article-quick-links__item--[tag]"><a href="[id]">[text]</a></p>`;

        if (!this.article || !this.headers.length > 0) return;

        this.init()
    }

    init() {
        this.headers.forEach((header) => {
            let headerText = header.innerText,
                headerId = header.getAttribute("id"),
                headerTag = header.tagName.toLowerCase();
 
            if (headerId == null) {
                // Ensure the header has an ID. Assign one using a handleized
                // version of the innerText if one doesn't already exist.
                headerId = slugify(headerText);
                header.setAttribute("id", headerId);
            }

            // Now all our headers have an ID attribute, we add our quick links.
            this.insertAdjacentHTML(
                'beforeend',
                this.markup.replace('[id]', `#${headerId}`)
                           .replace('[text]', headerText)
                           .replace('[tag]', headerTag)
            );

            // Once we know one link exists within the quick links block, we
            // remove the 'hidden' class to reveal the block.
            this.classList.remove('hidden');
        });
    }
}

customElements.define('article-quick-links', ArticleQuickLinks);